export default {
    about: {
        aboutPage: "about",
        pricesPage: "prices",
        privacyPolicyPage: "privacyPolicy"
    }
}